
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Cia8R", function(module, exports) {

$parcel$export(module.exports, "SearchComponent", () => $e662c27557dd8094$export$4c7a03676454bcb7);
/* SearchComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $inPa6 = parcelRequire("inPa6");

var $M3hWz = parcelRequire("M3hWz");

var $6mKj3 = parcelRequire("6mKj3");

var $e4o8D = parcelRequire("e4o8D");

var $fsMoS = parcelRequire("fsMoS");
var $escKD = parcelRequire("escKD");
var $5bPOK = parcelRequire("5bPOK");

var $dPJCf = parcelRequire("dPJCf");

var $dEBDF = parcelRequire("dEBDF");

var $lBYCH = parcelRequire("lBYCH");

var $jlIaF = parcelRequire("jlIaF");

var $luv00 = parcelRequire("luv00");
const $e662c27557dd8094$var$StyledContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $e662c27557dd8094$export$4c7a03676454bcb7 = ({ theme: theme })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const fireAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'quickSearch',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        routeDataRef
    ]);
    const searchComponent = (0, $gwFzn.useMemo)(()=>{
        /* If this user has Quick Find and is part of the SSR experiment, always
     * render the Quick Find regardless of whether it's client or server side.
     * We must do this check at this level as the Quick Search component is
     * not SSR compatible, whilst the Quick Find component is.
     */ if (isQuickFindEnabled && (0, $6mKj3.expValEquals)('confluence_quick_find_ssr', 'cohort', 'test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $escKD.QuickFindNav3), null);
        /**
     * Both Quick Find and Quick Search are compatible with the SSR placeholder.
     * There is logic within NavigationSearchDialog which determines whether
     * Quick Find or Quick Search is rendered.
     */ if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $M3hWz.ProductSearchInputSkeletonInteractiveSSR), {
            placeholder: "Search",
            advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
            shouldFillContainer: true
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fsMoS.NavigationSearchDialog), {
            theme: theme,
            clearStickySearchRef: resetStickySearchRef
        });
    }, [
        isQuickFindEnabled,
        renderServerPlaceholder,
        resetStickySearchRef,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e662c27557dd8094$var$StyledContainer, {
        "data-testid": "app-navigation-search",
        "data-vc": "app-navigation-search",
        ...ssrPlaceholderIdProp,
        onClick: fireAnalytics
    }, searchComponent);
};

});


//# sourceMappingURL=SearchComponent.10050b73.js.map
